import './emtNewDetailSkeleton.scss';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function EmtNewDetailSkeleton() {
  return (
    <div className='emt-new-detail-skeleton'>
      <Skeleton height={70} duration={0.5}/>
      <Skeleton height={350} duration={0.5}/>
      {new Array(8).fill(null).map((_, index) => (
          <Skeleton key={'emt-new-detail-list'+index} height={20} duration={0.5} />
      ))}
    </div>
  );
}
